<template>
     <label class="btn btn-outline-secondary" :class='classObject' @click="setBrand">
        <input type="radio" name="options" id="option1" autocomplete="off">
        <img class="brand-logo" :src="brand.get('data').logo"></img>
    </label>
</template>

<script>
export default {
  name: 'BrandButton',
  props: {
    brand: null,
    current: null
  },
  data () {
    return {
    }
  },
  methods: {
    setBrand () {
      this.$emit('click', this.brand)
    }
  },
  computed: {
    classObject: function () {
      if (this.brand && this.current) {
        return {active: this.brand.id === this.current.id}
      }
      return {active: false}
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .brand-logo
  {
    width : 8vw;
    height: 8vh;
    object-fit: contain;
  }
</style>


// WEBPACK FOOTER //
// src/components/params/BrandButton.vue